// internal
import { axios, def, array, handleError, handleResponse } from './internal';

function CommentList(postId, start, stop, setData, buildCommentTree, onSuccess) {
    setData((prev) => ({ ...prev, loading: true }));

    axios
        .get(`/api/posts/${encodeURIComponent(postId)}/comments`, { params: { start, stop }, guest: true })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    const { loadmore, comments } = res.data.data;
                    setData((prev) => {
                        const data = array.concatArray(prev.data, comments);
                        const treeData = buildCommentTree(data);
                        return {
                            ...prev,
                            start: start + comments.length,
                            loadmore: loadmore,
                            data: data,
                            treeData: treeData,
                        };
                    });
                    onSuccess?.();
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        })
        .finally(() => {
            setData((prev) => ({ ...prev, loading: false }));
        });
}

// Best-effort status poll for PROCESSING comments. Resolves to { [commentId]: { status, content } } (empty on any
// error, so the caller's polling just retries; ids not stored yet are missing).
function CommentRefresh(ids) {
    return axios
        .get('/api/comments/status', { params: { ids: ids.join(',') }, guest: true })
        .then((res) => (res.data.code === def.ErrorCode.OK ? res.data.data.statuses : {}))
        .catch(() => ({}));
}

export { CommentList, CommentRefresh };
